import { Component, OnInit } from '@angular/core';
import { IdP } from '../models/idp';
import { Alert } from '../shared/alert';
import { AppTitle } from '../shared/title';
import { ActivatedRoute, Router } from '@angular/router';
import { IdentityService } from '../services/identity.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DropdownOption } from '../shared/dropdown_option';
import { FindIdP } from '../models/find_idp';
import { controlErrors } from '../shared/app.validators';
import { IdPRequest } from '../models/idp_request';
@Component({
  selector: 'app-idp-add-edit',
  template: `
    <div class="row" [hidden]="msgHead.msg == ''">
        <div class="col-lg-8 col-md-6 col-xs-12">
            <alert [alert]="msgHead"></alert>
        </div>
    </div>
    <div *ngIf="hasAccess" class="row">
        <div class="col-lg-12 col-md-12 col-xs-12" style="padding:0px; margin-bottom:0px;">
            <form [formGroup]="form" novalid>
                <div class="row">
                    <div class="col-lg-3 col-md-6 col-xs-12" style="margin-bottom: 0px;">
                        <div class="form-group">
                            <p class="custom-label">Name</p>
                            <input type="text" [(ngModel)]="data.name" formControlName="name" class="form-control" placeholder="Name" title="Name">
                        </div>
                        <div class="form-group">
                            <p class="custom-label">Domain Names (comma separated)</p>
                            <input type="text" [(ngModel)]="data.domainNames" formControlName="domainNames" class="form-control" placeholder="Domain Names" title="Domain Names">
                        </div>
                        <div class="form-group">
                            <p class="custom-label">Protocol</p>
                            <select [(ngModel)]="data.protocol" formControlName="protocol" class="form-control" title="Protocol">
                                <option *ngFor="let pr of protocols; let i = index" [value]="pr.id">{{pr.title}}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="col-lg-12 col-md-12 col-xs-12" style="margin-top:0px;">
            <button type="button" class="btn btn-large btn-primary" (click)="save()">Continue</button>
            <a style="margin-left:10px;cursor: pointer;" (click)="goBack()">Go Back</a>
        </div>
    </div>
    <div *ngIf="hasAccess" class="row">
        <div class="col-lg-6 col-md-6 col-xs-12">
            <alert [alert]="msg" style="display:block;"></alert>
        </div>
    </div>
  `,
})
export class AddEditIdPComponent implements OnInit {
    data: IdPRequest;
    msg: Alert;
    msgHead: Alert;
    acctNumber: string;
    hasAccess: boolean;
    form: FormGroup;
    protocols: DropdownOption[];
    idParam: string;
    editMode: boolean;

    constructor(private title: AppTitle, private activatedRoute: ActivatedRoute, private idsvc: IdentityService, private router: Router, fb: FormBuilder) {
        this.hasAccess = true;
        this.msg = new Alert();
        this.msgHead = new Alert();
        this.editMode = false;
        this.data = new IdP();
        this.data.protocol = 'saml-2.0';

        this.form = fb.group({
			name: ['', Validators.compose([Validators.required])],
			domainNames: ['', Validators.compose([Validators.required])],
			protocol: ['SAML-2.0'],
        });
    }

    ngOnInit() {
        let titleStr = 'Add New';

		this.acctNumber = this.activatedRoute.snapshot.params['acctNumber'];
        this.idParam = this.activatedRoute.snapshot.params['id'];

        if (this.acctNumber != null) {
            this.idsvc.validateAcctNumber(this.acctNumber)
                .subscribe(res => {
                    if (!res) {
                        this.msgHead.error(`You don't have access to this district number ${this.acctNumber}`);
                        this.hasAccess = false;
                    }
                }, err => {
                    console.log(err);
                    let e = this.idsvc.getUserErrorDefault(err);
                    this.msgHead.error(e);
                    this.hasAccess = false;
                })
        }
        this.protocols = [
			{ id: 'saml-2.0', title: 'SAML-2.0' },
        ];
        
        if (this.idParam) {
			this.editMode = true;
			this.loadData();
			titleStr = 'Edit';
		}

        this.title.setTitles({
            title: `${titleStr} - Identity Providers`,
            dashboard: `${titleStr} - Identity Providers`
        });
        this.title.setBreadcrumbs([
            { title: 'Identity Providers ', link: `/idp/${this.acctNumber}/idps` },
            { title: titleStr, link: `` }
        ]);
    }

    loadData() {
        let find = new FindIdP();
		find.id = parseInt(this.idParam);
		this.idsvc.findIdPApi(this.acctNumber, find)
			.subscribe((rows: IdP[]) => {
				this.msg.close();
				this.data = rows[0];
				this.form.get('name').setValue(this.data.name);
				this.form.get('domainNames').setValue(this.data.domainNames);
				this.form.get('protocol').setValue(this.data.protocol);
			}, err => {
				console.log(err);
				if (this.idsvc.isErrNotFound(err)) {
					this.msg.warning(this.idsvc.getUserError(err));
				} else {
					if (this.idsvc.isErrUnauthorized(err)) {
						this.hasAccess = false;
						this.msg.error(this.idsvc.getUserErrorDefault(err));
					} else {
						this.msg.error(this.idsvc.getUserErrorDefault(err));
					}
				}
			});
    }

    save() {
        if (!this.form.valid) {
			this.displayErrors(this.form);
			return;
        }
        this.data.name = this.form.get('name').value;
        this.data.protocol = this.form.get('protocol').value;
        this.data.domainNames = this.form.get('domainNames').value;

        if (this.editMode) {
            this.idsvc.updateIdPApi(this.acctNumber, this.data)
			.subscribe(res => {
                this.router.navigate([`idp/${this.acctNumber}/idps/${res.id}/config`], { queryParams: { name: this.data.name } });
                return;
            }, err => {
                console.log(err);
                let e = this.idsvc.getUserErrorDefault(err);
                this.msgHead.error(e);
            });
        } else {
            this.idsvc.addIdPApi(this.acctNumber, this.data)
                .subscribe(res => {
                    this.router.navigate([`idp/${this.acctNumber}/idps/${res.id}/config`], { queryParams: { name: this.data.name } });
                    return;
                }, err => {
                    console.log(err);
                    let e = this.idsvc.getUserErrorDefault(err);
                    this.msgHead.error(e);
                });
        }
    }

    displayErrors(f: FormGroup) {
		var message = '';
		controlErrors(f, (c: any, err: any) => {
			message += err + '<br>';
		});
		this.msg.errorHtml(message);
	}

    goBack() {
		this.router.navigate([`idp/${this.acctNumber}/idps`]);
		return;
	}

}
